import React, { useState } from "react";
import DashboardCards from "../components/DashboardCards";
import justforyouicon from "../assets/images/justforyouicon.png";
import plant_image from "../assets/images/plant_image.png";
import map_image from "../assets/images/map_image.png";
import { Link } from "react-router-dom";
import SearchBar from "../components/SearchBar";
import upcomming_exhibition_icon from "../assets/icons/upcomming_exhibition_icon.png";
import trending_image from "../assets/images/trending_image.png";
import upcomming_image from "../assets/images/upcomming_image.png";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import Navbar from "../components/Navbar";

const HomePage = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div className="w-full">
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>
      <div className="flex pr-4 pt-4 pl-4 justify-between w-[100%] flex--cards">
        <div className="w-[48%] card">
          <Link to="/dashboard/prospects">
            <DashboardCards
              heading="Prospects"
              info="View prospect status list for interacting"
              contacted="55"
              pending="07"
              negotiation="05"
              inactive="12"
              win="15"
              closed="06"
            />
          </Link>
        </div>
        <div className="w-[48%] mr-6 card">
          <DashboardCards
            heading="Customers"
            info="Check customer status list for interacting"
            contacted="55"
            pending="07"
            negotiation="05"
            inactive="12"
            win="15"
            closed="06"
          />
        </div>
      </div>

      <div className="flex items-center mt-6 mb-4 ml-4">
        <img src={justforyouicon} alt="just for you" />
        <div>Just for you</div>
      </div>

      <div className="flex justify-between items-center bg-[#FFFFFF] border w-[95%] ml-4 rounded-xl info--cards">
        <div className="w-[50%] ml-4 pt-2 card--one">
          <div className="text-[16px] mb-3">
            Daily delivery service from 11:00 - 20:00 with designers drawing
            inspiration from diverse traditions and global influences. This
            fusion of styles results in collections that tell a story, bridging
            the gap...
          </div>
          <div className="text-[14px] mb-3">
            <span className="text-[#F6B801]">Includes:</span>
            <span className="text-[#141414]">Lifestyle tips & trends</span>
          </div>
          <div className="text-[14px] mb-3">2 mins read</div>
          <div className="flex text-[14px] mb-3 h-8">
            <div className="w-[25%] flex justify-center items-center  border rounded-md mr-3 cursor-pointer">
              Top Rated
            </div>
            <div className="w-[25%] flex justify-center items-center border rounded-md mr-3 cursor-pointer">
              Trending
            </div>
            <div className="w-[25%] flex justify-center items-center border rounded-md cursor-pointer">
              Most Read
            </div>
          </div>
        </div>
        <div className="p-4 relative">
          <img
            src={plant_image}
            alt="plant"
            className="w-[430px] h-[192px] object-cover rounded-xl"
          />
          <img
            src={trending_image}
            alt="trending"
            className="absolute bottom-4 right-4"
          />
        </div>
      </div>
      <div className="flex items-center mt-6 mb-4 ml-4">
        <img src={upcomming_exhibition_icon} alt="upcomming exhibition" />
        <div className="pl-1">Upcoming Exhibition</div>
      </div>

      <div className="flex justify-between bg-[#FFFFFF] border w-[95%] ml-4 rounded-xl mb-12 info--cards">
        <div className="w-6/12 ml-4 pt-4">
          <div className="font-bold mb-4">Exhibition Name</div>
          <div className="text-[16px] mb-3">23rd Nov 2023 - 12th Dec 2023</div>
          <div className="text-[14px] mb-3">10:00am - 13:00pm</div>
          <div className="text-[14px] mb-3">
            Flat No. 302, Sunshine Apartments, Mahatma Gandhi Road, Mumbai,
            Maharashtra 400001, India
          </div>
          <div>
            <button className="bg-[#2F80ED] py-1 px-28 rounded-md text-white mb-4">
              Invite Users
            </button>
          </div>
        </div>
        <div className="p-4 relative">
          <img
            src={map_image}
            alt="map"
            className="w-[430px] h-[192px] object-cover rounded-xl"
          />
          <img
            src={upcomming_image}
            alt="upcomming"
            className="absolute bottom-6 right-4"
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
